/* ============================================================
   TDHQ footer behaviour — tdhq-footer.js

   Scope is deliberately narrow. The spec rules out using JavaScript to
   render footer links, decide company information, hide inaccessible
   content after load, or compute anything Liquid already knows. All of
   that is server-rendered; this file only handles the mobile
   accordions and analytics.

   The footer must stay fully usable if this never loads: panels are
   only collapsed once JS has confirmed it can expand them again.
   ============================================================ */
(function () {
  'use strict';

  if (window.__tdhqFooterLoaded) return;
  window.__tdhqFooterLoaded = true;

  var footer = document.querySelector('[data-tdhq-footer]');
  if (!footer) return;

  /* ---------------------------------------------------------
     ACCORDIONS
     Real <button> elements with aria-expanded / aria-controls.
     --------------------------------------------------------- */
  (function accordions() {
    var toggles = footer.querySelectorAll('[data-tdhq-acc]');
    if (!toggles.length) return;

    var mq = window.matchMedia('(max-width: 767px)');

    function apply() {
      var mobile = mq.matches;
      /* the CSS keeps the panels shut until this has run (tdhq-footer.css, 22 Oct 2026) */
      footer.setAttribute('data-acc-ready', '');
      Array.prototype.forEach.call(toggles, function (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;

        if (mobile) {
          // Collapse only on mobile, and only now that JS is running — if this
          // file fails to load the panels stay open and every link is reachable.
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          panel.hidden = !expanded;
        } else {
          // Desktop shows all columns; clear the attribute so the hidden state
          // can never leak across a resize.
          panel.hidden = false;
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* OPEN AND CLOSE GLIDE (audit MOT-01). The panel used to jump from 0 to
       262px between two frames and back, while every other accordion on the
       site tweens. Height, the bottom padding and opacity run over 220ms on
       the site's easing, from whatever height is on screen, so a second tap
       mid-way reverses smoothly instead of snapping. A superseded animation
       is cancelled and its finish handler checks it is still the current
       one, so it can never hide a panel the shopper has just re-opened.
       Reduced motion: the panel simply shows or hides. */
    var EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
    Array.prototype.forEach.call(toggles, function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (!panel.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { panel.hidden = open; return; }
        var wasHidden = panel.hidden;
        var from = wasHidden ? 0 : panel.getBoundingClientRect().height;
        var fromPb = wasHidden ? '0px' : getComputedStyle(panel).paddingBottom;
        var fromOp = wasHidden ? 0 : +getComputedStyle(panel).opacity;
        if (panel._acc) { panel._acc.cancel(); }
        panel.hidden = false;
        var full = panel.scrollHeight;
        var pb = getComputedStyle(panel).paddingBottom;
        panel.style.overflow = 'hidden';
        var a = panel.animate({
          height: [from + 'px', (open ? 0 : full) + 'px'],
          paddingBottom: [fromPb, open ? '0px' : pb],
          opacity: [fromOp, open ? 0 : 1]
        }, { duration: (window.TdhqMotion ? window.TdhqMotion.ms('--tdhq-t', 220) : 220), easing: EASE });
        panel._acc = a;
        a.onfinish = function () {
          if (panel._acc !== a) { return; }
          panel._acc = null;
          panel.style.overflow = '';
          if (btn.getAttribute('aria-expanded') !== 'true') { panel.hidden = true; }
        };
      });
    });

    mq.addEventListener('change', apply);
    apply();
  })();

  /* ---------------------------------------------------------
     ANALYTICS
     Non-personal parameters only. customer_state comes from a
     server-rendered data attribute, never from reading customer
     data in JS — and the points balance and name are never sent.
     --------------------------------------------------------- */
  (function analytics() {
    var panel = footer.querySelector('[data-tdhq-account]');
    var state = (panel && panel.getAttribute('data-state')) || 'guest';

    footer.addEventListener('click', function (e) {
      var el = e.target.closest('[data-tdhq-fevent]');
      if (!el) return;

      var detail = {
        customer_state: state,
        link_category: el.getAttribute('data-link-category') || '',
        link_label: (el.textContent || '').trim().slice(0, 60),
        device_type: window.innerWidth < 768 ? 'mobile'
                   : window.innerWidth < 1100 ? 'tablet' : 'desktop'
      };

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: el.getAttribute('data-tdhq-fevent') }, detail));
      }
      document.dispatchEvent(new CustomEvent('tdhq:' + el.getAttribute('data-tdhq-fevent'), { detail: detail }));
    });
  })();
})();
